export const downloadQRs = ({
  response,
  fileName,
  type = 'application/zip',
}: {
  response: any;
  fileName: string;
  type?: string;
}) => {
  const blob = new Blob([response.data], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return response.data;
};
